import { useState } from "react";
import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState, useDebounce } from "@miplatform/hooks";

export const useManageLaborRatesViewModel = () => {
  const [laborRates, setLaborRates] = useState([]);
  const [recentLaborRates, setRecentLaborRates] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [filter, setFilter] = useState({});
  const [search, setSearch] = useState("");

  const debouncedSearch = useDebounce(search);
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();

  const handleRefresh = () => setRefresh((prev) => !prev);

  const getLaborRates = ({ top, skip } = {}) =>
    stateManager.run(async () =>
      accountService.laborRates.getAll({
        sort: ["name"],
        top,
        skip,
        filters: { ...filter, name: { contains: debouncedSearch } },
      })
    );

  const getRecentLaborRates = ({ sort, top, filters } = {}) => {
    return stateManager.run(async () =>
      accountService.laborRates.getAll({
        sort,
        top,
        filters: { ...filter, ...filters },
      })
    );
  };

  const deleteLaborRate = async (data) => {
    stateManager.run(async () => {
      const response = await accountService.laborRates.delete({
        ...data,
        toastMessageConfig: {
          success: { text: "Labor Rate Deleted Successfully!" },
          failure: { text: "Failed to delete labor rate." },
        },
      });

      if (response.status === HTTP_STATUSES.OK) {
        handleRefresh();
      }
    });
  };

  return {
    laborRates,
    isLoading,
    refresh,
    setLaborRates,
    recentLaborRates,
    setRecentLaborRates,
    getLaborRates,
    getRecentLaborRates,
    deleteLaborRate,
    handleRefresh,
    filter,
    setFilter,
    setSearch,
    debouncedSearch,
    search,
  };
};
